'use client';
import * as React from 'react';

/* eslint-disable @typescript-eslint/ban-ts-comment */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function renderElem({ root, ref, renderProps, props, children }) {
    if (typeof renderProps.render === 'function') {
        return renderProps.render(_object_spread_props(_object_spread({}, props), {
            children
        }), ref);
    }
    const Element = renderProps.as || renderProps.component || root;
    if (children !== null && children !== undefined) {
        return(// @ts-ignore
        /*#__PURE__*/ React.createElement(Element, _object_spread_props(_object_spread({}, props), {
            ref: ref
        }), children));
    }
    // @ts-ignore
    return /*#__PURE__*/ React.createElement(Element, _object_spread_props(_object_spread({}, props), {
        ref: ref
    }));
}

export { renderElem };
